

























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class TopInstance extends Vue {
  @Prop() name: any;
  @Prop() website_link: any;
  @Prop() avatar: any;
  @Prop() image_1: any;
  @Prop() image_2: any;

  public get url_1(): string {
    return this.image_1?.url || "";
  }

  public get url_2(): string {
    return this.image_2?.url || "";
  }
}
